var { mat4, vec4, vec3 } = require('gl-matrix');
var vsSource = require('./vert.glsl');
var fsSource = require('./frag.glsl');

var scripts = document.getElementsByTagName('script');
var lastScript = scripts[scripts.length - 1];
var scriptName = lastScript.src;
document.getElementById('version').innerText = scriptName.split('/').pop();

setTimeout(init, 1);

function init() {
	var canvas = document.getElementById('c');
	var width = canvas.clientWidth;
	var height = canvas.clientHeight;
	canvas.width = width;
	canvas.height = height;

	var gl = canvas.getContext("webgl");
	gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);

	var shaderProgram = initShaderProgram(gl, vsSource, fsSource);
	var buffers = initBuffers(gl);

	const programInfo = {
		program: shaderProgram,
		attribLocations: {
			vertexPosition: gl.getAttribLocation(shaderProgram, 'aVertexPosition'),
		},
		uniformLocations: {
			viewProjectionInverseMatrix: gl.getUniformLocation(shaderProgram, 'uViewProjectionInverse'),
			cameraPosition: gl.getUniformLocation(shaderProgram, 'cameraPosition'),
		},
	};

	drawScene(gl, programInfo, buffers);
}

function initShaderProgram(gl, vsSource, fsSource) {
	const vertexShader = loadShader(gl, gl.VERTEX_SHADER, vsSource);
	const fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, fsSource);

	// Create the shader program
	const shaderProgram = gl.createProgram();
	gl.attachShader(shaderProgram, vertexShader);
	gl.attachShader(shaderProgram, fragmentShader);
	gl.linkProgram(shaderProgram);

	// If creating the shader program failed, alert
	if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
		alert('Unable to initialize the shader program: ' + gl.getProgramInfoLog(shaderProgram));
		return null;
	}

	return shaderProgram;
}



function loadShader(gl, type, source) {
	const shader = gl.createShader(type);

	gl.shaderSource(shader, source);
	gl.compileShader(shader);

	if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
		alert('An error occurred compiling the shaders: ' + gl.getShaderInfoLog(shader));
		gl.deleteShader(shader);
		return null;
	}

	return shader;
}



function initBuffers(gl) {
	const positionBuffer = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);

	const positions = [
		1.0, 1.0,
		-1.0, 1.0,
		1.0, -1.0,
		-1.0, -1.0,
	];

	gl.bufferData(gl.ARRAY_BUFFER,
		new Float32Array(positions),
		gl.STATIC_DRAW);

	return {
		position: positionBuffer,
	};
}



function drawScene(gl, programInfo, buffers) {
	gl.clearColor(1.0, 0.0, 0.0, 1.0);  // Clear to black, fully opaque
	gl.clearDepth(1.0);                 // Clear everything
	gl.enable(gl.DEPTH_TEST);           // Enable depth testing
	gl.depthFunc(gl.LEQUAL);            // Near things obscure far things

	gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);

	var fovRadians = Math.PI / 2;
	var aspectRatio = gl.canvas.clientHeight / gl.canvas.clientWidth;

	var camera = {
		position: vec4.fromValues(-0.5, 1.5, 0.0, 1.0),
		lookAt: vec4.fromValues(1.0, 0.5, -3.0, 1.0),
		up: vec4.fromValues(0.0, 1.0, 0.0, 0.0)
	};

	var projection = mat4.create();
	mat4.perspective(projection, fovRadians, aspectRatio, .1, 100);

	var view = mat4.create();
	mat4.lookAt(view, camera.position, camera.lookAt, camera.up);

	var viewProjection = mat4.create();
	mat4.multiply(viewProjection, projection, view);

	var viewProjectionInverse = mat4.create();
	mat4.invert(viewProjectionInverse, viewProjection);

	{
		const numComponents = 2;  // pull out 2 values per iteration
		const type = gl.FLOAT;    // the data in the buffer is 32bit floats
		const normalize = false;  // don't normalize
		const stride = 0;         // how many bytes to get from one set of values to the next
		// 0 = use type and numComponents above
		const offset = 0;         // how many bytes inside the buffer to start from
		gl.bindBuffer(gl.ARRAY_BUFFER, buffers.position);
		gl.vertexAttribPointer(
			programInfo.attribLocations.vertexPosition,
			numComponents,
			type,
			normalize,
			stride,
			offset);
		gl.enableVertexAttribArray(
			programInfo.attribLocations.vertexPosition);
	}

	gl.useProgram(programInfo.program);

	gl.uniformMatrix4fv(
		programInfo.uniformLocations.viewProjectionInverseMatrix,
		false,
		viewProjectionInverse);
	gl.uniform4fv(
		programInfo.uniformLocations.cameraPosition,
		camera.position);

	{
		const offset = 0;
		const vertexCount = 4;
		gl.drawArrays(gl.TRIANGLE_STRIP, offset, vertexCount);
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/webgl/index.js
// module id = 4
// module chunks = 0